/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/react';
import * as styles from './styles';
/**
 * Test id for wrapper FlashAnimation div
 */
export var RENDER_FLASHANIMATION_TESTID = 'flash-animation';

/**
 * Flash animation background component. See Reaction component for usage.
 */
export var FlashAnimation = function FlashAnimation(props) {
  return jsx("div", {
    className: props.className,
    css: [styles.containerStyle, props.flash && styles.flashStyle],
    "data-testid": RENDER_FLASHANIMATION_TESTID
  }, props.children);
};